import type { IconNames } from '@workramp/ui';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { ReportType } from '~/types/reports';
import { APP_CONSTANTS } from '~/common/explicit-exports';

export const ICON_MAP: Record<string, IconNames> = {
  [AssetPickerTypes.CHALLENGE]: 'challenge:regular',
  [AssetPickerTypes.CLASS]: 'event:regular',
  [AssetPickerTypes.EVENT]: 'event:regular',
  [AssetPickerTypes.FOLDER]: 'folder-closed:regular',
  [AssetPickerTypes.GO1_CONTENT]: 'search:regular',
  // TODO: We need icons ported from legacy for GUIDE_SECTION and GUIDE_TASK
  [AssetPickerTypes.GUIDE]: 'guide:regular',
  [AssetPickerTypes.LIBRARY]: 'library:regular',
  [AssetPickerTypes.LINKEDIN_LEARNING]: 'linkedin:brand',
  [AssetPickerTypes.PATH]: 'path:regular',
  [AssetPickerTypes.RESOURCE]: 'resource:regular',
  [AssetPickerTypes.EVENT_TEMPLATE]: 'schedule-template:regular',
  [AssetPickerTypes.SCORM]: 'scorm:regular',
  [AssetPickerTypes.SERIES]: 'path:regular',
  [AssetPickerTypes.UDEMY]: 'udemy:brand',
  [AssetPickerTypes.UNIVERSITY]: 'library:regular',
  [AssetPickerTypes.ASSET]: 'assets:regular',
  [ReportType.AUDIT_LOGS]: 'file-search:regular',
  [ReportType.BADGES]: 'badge:regular',
  [ReportType.CHALLENGES]: 'challenge:regular',
  [ReportType.CHALLENGE_SUBMISSIONS]: 'textblock:regular',
  [ReportType.CONTENT_PROVIDER_CONTENT]: 'scorm:regular',
  [ReportType.EVENTS]: 'event:regular',
  [ReportType.GROUPS]: 'group:regular',
  [ReportType.GUIDES]: 'guide:regular',
  [ReportType.GUIDE_SUBMISSIONS]: 'textblock:regular',
  [ReportType.LIBRARIES]: 'library:regular',
  [ReportType.RESOURCES]: 'resource:regular',
  [ReportType.SERIES]: 'path:regular',
  [ReportType.GUIDE_SUBMISSIONS_NEW]: 'textblock:regular',
  [ReportType.TRAININGS]: 'guide:regular',
  [ReportType.USERS]: 'profile:regular',
};

export const ICON_WITH_SUBTYPE_MAP: Record<string, Record<string, IconNames>> = {
  [APP_CONSTANTS.CONTENT_PROVIDER_TOP_LEVEL_CONTENT_TYPE]: {
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY]: 'udemy:brand',
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING]: 'linkedin:brand',
  },
  [APP_CONSTANTS.SCORM_TOP_LEVEL_CONTENT_TYPE]: {
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.EASYLLAMA]: 'scorm:regular',
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.ETHENA]: 'scorm:regular',
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.GO1]: 'scorm:regular',
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.NINJIO]: 'scorm:regular',
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY]: 'udemy:brand',
    [APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING]: 'linkedin:brand',
  },
};

export const ICON_MAP_DUOTONE: Record<string, IconNames> = {
  [AssetPickerTypes.CHALLENGE]: 'challenge:duotone',
  [AssetPickerTypes.CLASS]: 'event:duotone',
  [AssetPickerTypes.EVENT]: 'event:duotone',
  [AssetPickerTypes.GO1_CONTENT]: 'content:duotone',
  [AssetPickerTypes.GUIDE]: 'guide:duotone',
  [AssetPickerTypes.LIBRARY]: 'library:duotone',
  [AssetPickerTypes.LINKEDIN_LEARNING]: 'linkedin:brand',
  [AssetPickerTypes.PATH]: 'path:duotone',
  [AssetPickerTypes.RESOURCE]: 'resource:duotone',
  [AssetPickerTypes.EVENT_TEMPLATE]: 'schedule-template:duotone',
  [AssetPickerTypes.SCORM]: 'scorm:duotone',
  [AssetPickerTypes.SERIES]: 'path:duotone',
  [AssetPickerTypes.UDEMY]: 'udemy:brand',
  [AssetPickerTypes.UNIVERSITY]: 'library:duotone',
  [ReportType.CHALLENGES]: 'challenge:duotone',
  [ReportType.CONTENT_PROVIDER_CONTENT]: 'scorm:duotone',
  [ReportType.EVENTS]: 'event:duotone',
  [ReportType.GUIDES]: 'guide:duotone',
  [ReportType.LIBRARIES]: 'library:duotone',
  [ReportType.RESOURCES]: 'resource:duotone',
  [ReportType.SERIES]: 'path:duotone',
  [ReportType.TRAININGS]: 'guide:duotone',
};
